import Input, { InputField, MaskedInputField } from '~/components/Input/Input';

export default Input;
export { InputField, MaskedInputField };
